<!-- 差分比較ダイアログ -->
<p-dialog header=" " [modal]="true" [(visible)]="diffTableDialogFlag" styleClass="diff-table">
  <div class="content" [class.platform-large-text]="getTextSize()">
    <!-- 前後確認 -->
    <p-table [value]="[{}]" styleClass="information-Form">
      <ng-template pTemplate="header">
        <!-- タイトル -->
        <tr [class.platform-large-text]="getTextSize()">
          <th colspan="3" class="header-title">差分比較ダイアログ</th>
        </tr>
        <tr [class.platform-large-text]="getTextSize()">
          <th class="item-name">項目名</th>
          <th class="item-name">更新前</th>
          <th class="item-name">更新後</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body">
        <!-- 内容詳細 -->
        <!--------------------------------------------------------------------------------------------->
        <!-- c601 提案 -->
        <!--------------------------------------------------------------------------------------------->

        <!--------------------------- 提案 ------------------------------------------------------------------>
        <ng-container *ngIf="screen_id == 'c601' && 'suggest' == suggestOrRequest">
          <!-- 提案タイトル -->
          <tr>
            <td class="item-name">提案タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'title') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'title') == checkNull(searchResultList, 'title')">{{
              checkNull(searchResultList, 'title') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'title') != checkNull(searchResultList, 'title')">{{
              checkNull(searchResultList, 'title') }}</td>
          </tr>
          <!-- 提案内容詳細 -->
          <tr>
            <td class="item-name">提案内容詳細</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'detail') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'detail') == checkNull(searchResultList, 'detail')">{{
              checkNull(searchResultList, 'detail') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'detail') != checkNull(searchResultList, 'detail')">{{
              checkNull(searchResultList, 'detail') }}</td>
          </tr>
          <!-- 導入事例・実績等 -->
          <tr>
            <td class="item-name">導入事例・実績等</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'case') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'case') == checkNull(searchResultList, 'case')">{{
              checkNull(searchResultList, 'case') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'case') != checkNull(searchResultList, 'case')">{{
              checkNull(searchResultList, 'case') }}</td>
          </tr>
        </ng-container>

        <!--------------------------- 依頼 ------------------------------------------------------------------>
        <ng-container *ngIf="screen_id == 'c601' && 'request' == suggestOrRequest">
          <!-- 依頼タイトル -->
          <tr>
            <td class="item-name">依頼タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'title') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'title') == checkNull(searchResultList, 'title')">{{
              checkNull(searchResultList, 'title') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'title') != checkNull(searchResultList, 'title')">{{
              checkNull(searchResultList, 'title') }}</td>
          </tr>
          <!-- 依頼内容 -->
          <tr>
            <td class="item-name">依頼内容</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'detail') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'detail') == checkNull(searchResultList, 'detail')">{{
              checkNull(searchResultList, 'detail') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'detail') != checkNull(searchResultList, 'detail')">{{
              checkNull(searchResultList, 'detail') }}</td>
          </tr>
          <!-- 質問事項 -->
          <tr>
            <td class="item-name">質問事項</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'question') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'question') == checkNull(searchResultList, 'question')">{{
              checkNull(searchResultList, 'question') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'question') != checkNull(searchResultList, 'question')">{{
              checkNull(searchResultList, 'question') }}</td>
          </tr>
          <!-- 参考情報 -->
          <tr>
            <td class="item-name">参考情報</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'reference') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'reference') == checkNull(searchResultList, 'reference')">{{
              checkNull(searchResultList, 'reference') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'reference') != checkNull(searchResultList, 'reference')">{{
              checkNull(searchResultList, 'reference') }}</td>
          </tr>
        </ng-container>
        <!--------------------------------------------------------------------------------------------->
        <!-- e202 分科会 -->
        <!--------------------------------------------------------------------------------------------->
        <ng-container *ngIf="screen_id == 'e202'">
          <!-- タイトル -->
          <tr>
            <td class="item-name">タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'theme') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'theme') == checkNull(searchResultList, 'theme')">{{
              checkNull(searchResultList, 'theme') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'theme') != checkNull(searchResultList, 'theme')">{{
              checkNull(searchResultList, 'theme') }}</td>
          </tr>
          <!-- 分科会の目的 -->
          <tr>
            <td class="item-name">分科会の目的</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'purpose') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'purpose') == checkNull(searchResultList, 'purpose')">{{
              checkNull(searchResultList, 'purpose') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'purpose') != checkNull(searchResultList, 'purpose')">{{
              checkNull(searchResultList, 'purpose') }}</td>
          </tr>
          <!-- 解決したい課題 -->
          <tr>
            <td class="item-name">解決したい課題</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'agenda') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'agenda') == checkNull(searchResultList, 'agenda')">{{
              checkNull(searchResultList, 'agenda') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'agenda') != checkNull(searchResultList, 'agenda')">{{
              checkNull(searchResultList, 'agenda') }}</td>
          </tr>
          <!-- 活動概要 -->
          <tr>
            <td class="item-name">活動概要</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'outline') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'outline') == checkNull(searchResultList, 'outline')">{{
              checkNull(searchResultList, 'outline') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'outline') != checkNull(searchResultList, 'outline')">{{
              checkNull(searchResultList, 'outline') }}</td>
          </tr>
          <!-- 活動内容1 -->
          <tr *ngIf="decisionLoginState()">
            <td class="item-name">活動内容1</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'note1') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'note1') == checkNull(searchResultList, 'note1')">{{
              checkNull(searchResultList, 'note1') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'note1') != checkNull(searchResultList, 'note1')">{{
              checkNull(searchResultList, 'note1') }}</td>
          </tr>
          <!-- 活動内容2 -->
          <tr *ngIf="decisionLoginState()">
            <td class="item-name">活動内容2</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'note2') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'note2') == checkNull(searchResultList, 'note2')">{{
              checkNull(searchResultList, 'note2') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'note2') != checkNull(searchResultList, 'note2')">{{
              checkNull(searchResultList, 'note2') }}</td>
          </tr>
          <!-- 活動内容3 -->
          <tr *ngIf="decisionLoginState()">
            <td class="item-name">活動内容3</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'note3') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'note3') == checkNull(searchResultList, 'note3')">{{
              checkNull(searchResultList, 'note3') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'note3') != checkNull(searchResultList, 'note3')">{{
              checkNull(searchResultList, 'note3') }}</td>
          </tr>
          <!-- 期待される成果 -->
          <tr>
            <td class="item-name">期待される成果</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'outcome') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'outcome') == checkNull(searchResultList, 'outcome')">{{
              checkNull(searchResultList, 'outcome') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'outcome') != checkNull(searchResultList, 'outcome')">{{
              checkNull(searchResultList, 'outcome') }}</td>
          </tr>
          <!-- 資金・物資計画 -->
          <tr *ngIf="decisionLoginState()">
            <td class="item-name">資金・物資計画</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'funding_plan') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'funding_plan') == checkNull(searchResultList, 'funding_plan')">{{
              checkNull(searchResultList, 'funding_plan') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'funding_plan') != checkNull(searchResultList, 'funding_plan')">{{
              checkNull(searchResultList, 'funding_plan') }}</td>
          </tr>
          <!-- 主に関連するゴール -->
          <tr *ngIf="decisionLoginState()">
            <td class="item-name">主に関連するゴール</td>
            <td class="item-information target-goal">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultLogList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
            <td class="item-information target-goal"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'sdgs_goal')) == convertJSONtoString(checkNull(searchResultList, 'sdgs_goal'))">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
            <td class="item-information target-goal unmatched"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'sdgs_goal')) != convertJSONtoString(checkNull(searchResultList, 'sdgs_goal'))">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
          </tr>
          <!-- 計画書概要 -->
          <tr>
            <td class="item-name">計画書概要</td>
            <td class="item-information">
              <div class="p-d-flex">
                <!-- ファイル名-->
                <div class="p-as-center">
                  {{ checkNull(searchResultLogList, 'image', 'name') }}
                </div>
                <!-- ファイルDL-->
                <button pButton label="ダウンロード" [value]="checkNull(searchResultLogList, 'image', 'file_path')"
                  onClick="window.open(this.value, '_blank')" class="button1 dlButton"
                  [disabled]="!checkNull(searchResultLogList, 'image', 'file_path')"></button>
              </div>
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'image', 'file_path') == checkNull(searchResultList, 'image', 'file_path')">
              <div class="p-d-flex">
                <!-- ファイル名-->
                <div class="p-as-center">
                  {{ checkNull(searchResultList, 'image', 'name') }}
                </div>
                <!-- ファイルDL-->
                <button pButton label="ダウンロード" [value]="checkNull(searchResultList, 'image', 'file_path')"
                  onClick="window.open(this.value, '_blank')" class="button1 dlButton"
                  [disabled]="!checkNull(searchResultList, 'image', 'file_path')"></button>
              </div>
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'image', 'file_path') != checkNull(searchResultList, 'image', 'file_path')">
              <div class="p-d-flex">
                <!-- ファイル名-->
                <div class="p-as-center">
                  {{ checkNull(searchResultList, 'image', 'name') }}
                </div>
                <!-- ファイルDL-->
                <button pButton label="ダウンロード" [value]="checkNull(searchResultList, 'image', 'file_path')"
                  onClick="window.open(this.value, '_blank')" class="button1 dlButton"
                  [disabled]="!checkNull(searchResultList, 'image', 'file_path')"></button>
              </div>
            </td>
          </tr>
          <!-- 参加してほしいメンバー -->
          <tr>
            <td class="item-name">参加してほしいメンバー</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'members_who_want') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'members_who_want') == checkNull(searchResultList, 'members_who_want')">
              {{ checkNull(searchResultList, 'members_who_want') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'members_who_want') != checkNull(searchResultList, 'members_who_want')">
              {{ checkNull(searchResultList, 'members_who_want') }}</td>
          </tr>
          <!-- 想定しているメンバー数 -->
          <tr>
            <td class="item-name">想定しているメンバー数</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'members_count') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'members_count') == checkNull(searchResultList, 'members_count')">{{
              checkNull(searchResultList, 'members_count') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'members_count') != checkNull(searchResultList, 'members_count')">{{
              checkNull(searchResultList, 'members_count') }}</td>
          </tr>
          <!-- メンバーへの期待 -->
          <tr>
            <td class="item-name">メンバーへの期待</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'members_expectation') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'members_expectation') == checkNull(searchResultList, 'members_expectation')">
              {{ checkNull(searchResultList, 'members_expectation') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'members_expectation') != checkNull(searchResultList, 'members_expectation')">
              {{ checkNull(searchResultList, 'members_expectation') }}</td>
          </tr>
          <!-- 実施スケジュール -->
          <tr>
            <td class="item-name">実施スケジュール</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'schedule') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'schedule') == checkNull(searchResultList, 'schedule')">{{
              checkNull(searchResultList, 'schedule') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'schedule') != checkNull(searchResultList, 'schedule')">{{
              checkNull(searchResultList, 'schedule') }}</td>
          </tr>
          <!-- その他特記事項 -->
          <tr>
            <td class="item-name">その他特記事項</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'note') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'note') == checkNull(searchResultList, 'note')">{{
              checkNull(searchResultList, 'note') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'note') != checkNull(searchResultList, 'note')">{{
              checkNull(searchResultList, 'note') }}</td>
          </tr>
          <!-- 主催（団体名称） -->
          <tr>
            <td class="item-name">主催（団体名称）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'organizer_group_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'organizer_group_name') == checkNull(searchResultList, 'organizer_group_name')">
              {{ checkNull(searchResultList, 'organizer_group_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'organizer_group_name') != checkNull(searchResultList, 'organizer_group_name')">
              {{ checkNull(searchResultList, 'organizer_group_name') }}</td>
          </tr>
          <!-- 主催（部署名） -->
          <tr>
            <td class="item-name">主催（部署名）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'organizer_divition_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'organizer_divition_name') == checkNull(searchResultList, 'organizer_divition_name')">
              {{ checkNull(searchResultList, 'organizer_divition_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'organizer_divition_name') != checkNull(searchResultList, 'organizer_divition_name')">
              {{ checkNull(searchResultList, 'organizer_divition_name') }}</td>
          </tr>
          <!-- 主催（担当者名） -->
          <tr>
            <td class="item-name">主催（担当者名）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'organizer_person_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'organizer_person_name') == checkNull(searchResultList, 'organizer_person_name')">
              {{ checkNull(searchResultList, 'organizer_person_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'organizer_person_name') != checkNull(searchResultList, 'organizer_person_name')">
              {{ checkNull(searchResultList, 'organizer_person_name') }}</td>
          </tr>
          <!-- 主催（電話番号） -->
          <tr>
            <td class="item-name">主催（電話番号）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'organizer_tel') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'organizer_tel') == checkNull(searchResultList, 'organizer_tel')">{{
              checkNull(searchResultList, 'organizer_tel') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'organizer_tel') != checkNull(searchResultList, 'organizer_tel')">{{
              checkNull(searchResultList, 'organizer_tel') }}</td>
          </tr>
          <!-- 主催（eメールアドレス） -->
          <tr>
            <td class="item-name">主催（eメールアドレス）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'organizer_email') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'organizer_email') == checkNull(searchResultList, 'organizer_email')">
              {{ checkNull(searchResultList, 'organizer_email') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'organizer_email') != checkNull(searchResultList, 'organizer_email')">
              {{ checkNull(searchResultList, 'organizer_email') }}</td>
          </tr>
          <!-- 窓口（団体名称） -->
          <tr>
            <td class="item-name">窓口（団体名称）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'reception_group_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'reception_group_name') == checkNull(searchResultList, 'reception_group_name')">
              {{ checkNull(searchResultList, 'reception_group_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'reception_group_name') != checkNull(searchResultList, 'reception_group_name')">
              {{ checkNull(searchResultList, 'reception_group_name') }}</td>
          </tr>
          <!-- 窓口（部署名） -->
          <tr>
            <td class="item-name">窓口（部署名）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'reception_divition_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'reception_divition_name') == checkNull(searchResultList, 'reception_divition_name')">
              {{ checkNull(searchResultList, 'reception_divition_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'reception_divition_name') != checkNull(searchResultList, 'reception_divition_name')">
              {{ checkNull(searchResultList, 'reception_divition_name') }}</td>
          </tr>
          <!-- 窓口（担当者名） -->
          <tr>
            <td class="item-name">窓口（担当者名）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'reception_person_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'reception_person_name') == checkNull(searchResultList, 'reception_person_name')">
              {{ checkNull(searchResultList, 'reception_person_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'reception_person_name') != checkNull(searchResultList, 'reception_person_name')">
              {{ checkNull(searchResultList, 'reception_person_name') }}</td>
          </tr>
          <!-- 窓口（電話番号） -->
          <tr>
            <td class="item-name">窓口（電話番号）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'reception_tel') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'reception_tel') == checkNull(searchResultList, 'reception_tel')">{{
              checkNull(searchResultList, 'reception_tel') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'reception_tel') != checkNull(searchResultList, 'reception_tel')">{{
              checkNull(searchResultList, 'reception_tel') }}</td>
          </tr>
          <!-- 窓口（eメールアドレス） -->
          <tr>
            <td class="item-name">窓口（eメールアドレス）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'reception_email') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'reception_email') == checkNull(searchResultList, 'reception_email')">
              {{ checkNull(searchResultList, 'reception_email') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'reception_email') != checkNull(searchResultList, 'reception_email')">
              {{ checkNull(searchResultList, 'reception_email') }}</td>
          </tr>
        </ng-container>
        <!--------------------------------------------------------------------------------------------->
        <!-- b212 会員プロフィール -->
        <!--------------------------------------------------------------------------------------------->
        <ng-container *ngIf="screen_id == 'b211' || screen_id == 'b212'">
          <!-- 会員種別 -->
          <tr>
            <td class="item-name">会員種別</td>
            <td class="item-information">
              <label *ngIf="9 != checkNull(searchResultLogList, 'class_id', 'id')">{{ checkNull(searchResultLogList,
                'class_id', 'name') }}</label>
              <label *ngIf="9 == checkNull(searchResultLogList, 'class_id', 'id')">事務局</label>
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'class_id', 'id') == checkNull(searchResultList, 'class_id', 'id')">
              <label *ngIf="9 != checkNull(searchResultList, 'class_id', 'id')">{{ checkNull(searchResultList,
                'class_id', 'name') }}</label>
              <label *ngIf="9 == checkNull(searchResultList, 'class_id', 'id')">事務局</label>
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'class_id', 'id') != checkNull(searchResultList, 'class_id', 'id')">
              <label *ngIf="9 != checkNull(searchResultList, 'class_id', 'id')">{{ checkNull(searchResultList,
                'class_id', 'name') }}</label>
              <label *ngIf="9 == checkNull(searchResultList, 'class_id', 'id')">事務局</label>
            </td>
          </tr>
          <!-- 団体名称カナ -->
          <tr>
            <td class="item-name">団体名称(フリガナ）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'organization_kana') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'organization_kana') == checkNull(searchResultList, 'organization_kana')">
              {{ checkNull(searchResultList, 'organization_kana') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'organization_kana') != checkNull(searchResultList, 'organization_kana')">
              {{ checkNull(searchResultList, 'organization_kana') }}</td>
          </tr>
          <!-- 法人番号 -->
          <tr>
            <td class="item-input-name">法人番号</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'organization_no') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'organization_no') == checkNull(searchResultList, 'organization_no')">
              {{ checkNull(searchResultList, 'organization_no') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'organization_no') != checkNull(searchResultList, 'organization_no')">
              {{ checkNull(searchResultList, 'organization_no') }}</td>
          </tr>
          <!-- 郵便番号 -->
          <tr>
            <td class="item-name">郵便番号</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'postal_no') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'postal_no') == checkNull(searchResultList, 'postal_no')">{{
              checkNull(searchResultList, 'postal_no') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'postal_no') != checkNull(searchResultList, 'postal_no')">{{
              checkNull(searchResultList, 'postal_no') }}</td>
          </tr>
          <!-- 都道府県 -->
          <tr>
            <td class="item-name">都道府県</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'prefectures') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'prefectures') == checkNull(searchResultList, 'prefectures')">{{
              checkNull(searchResultList, 'prefectures') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'prefectures') != checkNull(searchResultList, 'prefectures')">{{
              checkNull(searchResultList, 'prefectures') }}</td>
          </tr>
          <!-- 所在地 -->
          <tr>
            <td class="item-name">所在地</td>
            <td class="item-information">
              {{ checkNull(searchResultLogList, 'city') }}
              {{ checkNull(searchResultLogList, 'town_area') }}
              {{ checkNull(searchResultLogList, 'address_building') }}
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'city') == checkNull(searchResultList, 'city') &&
                       checkNull(searchResultLogList, 'town_area') == checkNull(searchResultList, 'town_area') &&
                       checkNull(searchResultLogList, 'address_building') == checkNull(searchResultList, 'address_building')">
              {{ checkNull(searchResultList, 'city') }}
              {{ checkNull(searchResultList, 'town_area') }}
              {{ checkNull(searchResultList, 'address_building') }}
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'city') != checkNull(searchResultList, 'city') ||
                       checkNull(searchResultLogList, 'town_area') != checkNull(searchResultList, 'town_area') ||
                       checkNull(searchResultLogList, 'address_building') != checkNull(searchResultList, 'address_building')">
              {{ checkNull(searchResultList, 'city') }}
              {{ checkNull(searchResultList, 'town_area') }}
              {{ checkNull(searchResultList, 'address_building') }}
            </td>
          </tr>
          <!-- 業種 -->
          <tr>
            <td class="item-name">業種</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'industry_id', 'name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'industry_id', 'name') == checkNull(searchResultList, 'industry_id', 'name')">
              {{ checkNull(searchResultList, 'industry_id', 'name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'industry_id', 'name') != checkNull(searchResultList, 'industry_id', 'name')">
              {{ checkNull(searchResultList, 'industry_id', 'name') }}</td>
          </tr>
          <!-- 人口 -->
          <tr
            *ngIf="(screen_id == 'b212' && 2 == checkNull(searchResultList, 'class_id', 'id') ) || screen_id == 'b211'">
            <td class="item-name">人口</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'population', 'name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'population', 'name') == checkNull(searchResultList, 'population', 'name')">
              {{ checkNull(searchResultList, 'population', 'name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'population', 'name') != checkNull(searchResultList, 'population', 'name')">
              {{ checkNull(searchResultList, 'population', 'name') }}</td>
          </tr>
          <!-- 従業員数 -->
          <tr
            *ngIf="(screen_id == 'b212' && 3 == checkNull(searchResultList, 'class_id', 'id') ) || screen_id == 'b211'">
            <td class="item-name">従業員数</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'employees_count', 'name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'employees_count', 'name') == checkNull(searchResultList, 'employees_count', 'name')">
              {{ checkNull(searchResultList, 'employees_count', 'name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'employees_count', 'name') != checkNull(searchResultList, 'employees_count', 'name')">
              {{ checkNull(searchResultList, 'employees_count', 'name') }}</td>
          </tr>
          <!-- 売上高 -->
          <tr
            *ngIf="(screen_id == 'b212' && 3 == checkNull(searchResultList, 'class_id', 'id') ) || screen_id == 'b211'">
            <td class="item-name">売上高</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'sales_amount', 'name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'sales_amount', 'name') == checkNull(searchResultList, 'sales_amount', 'name')">
              {{ checkNull(searchResultList, 'sales_amount', 'name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'sales_amount', 'name') != checkNull(searchResultList, 'sales_amount', 'name')">
              {{ checkNull(searchResultList, 'sales_amount', 'name') }}</td>
          </tr>
          <!-- 主要事業 -->
          <tr *ngIf="screen_id == 'b211'">
            <td class="item-name">主要事業</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'primary_business') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'primary_business') == checkNull(searchResultList, 'primary_business')">
              {{ checkNull(searchResultList, 'primary_business') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'primary_business') != checkNull(searchResultList, 'primary_business')">
              {{ checkNull(searchResultList, 'primary_business') }}</td>
          </tr>
          <!-- 活動で貴団体が実現したいこと -->
          <tr>
            <td class="item-name">
              本プラットフォームにおける<br />
              活動で実現したいこと
            </td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'want') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'want') == checkNull(searchResultList, 'want')">{{
              checkNull(searchResultList, 'want') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'want') != checkNull(searchResultList, 'want')">{{
              checkNull(searchResultList, 'want') }}</td>
          </tr>
          <!-- 主要事業 -->
          <tr *ngIf="screen_id == 'b212' && 3 == checkNull(searchResultList, 'class_id', 'id')">
            <td class="item-name">主要事業</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'primary_business') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'primary_business') == checkNull(searchResultList, 'primary_business')">
              {{ checkNull(searchResultList, 'primary_business') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'primary_business') != checkNull(searchResultList, 'primary_business')">
              {{ checkNull(searchResultList, 'primary_business') }}</td>
          </tr>
          <!-- 重点的に取り組みたいテーマ  -->
          <tr>
            <td class="item-name">重点的に取り組みたいテーマ</td>
            <td class="item-information">
              <div
                *ngFor="let category_activities_forcus of checkNull(searchResultLogList, 'category_activities_forcus')">
                {{ category_activities_forcus.name }}
              </div>
            </td>
            <td class="item-information"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'category_activities_forcus')) == convertJSONtoString(checkNull(searchResultList, 'category_activities_forcus'))">
              <div *ngFor="let category_activities_forcus of checkNull(searchResultList, 'category_activities_forcus')">
                {{ category_activities_forcus.name }}
              </div>
            </td>
            <td class="item-information unmatched"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'category_activities_forcus')) != convertJSONtoString(checkNull(searchResultList, 'category_activities_forcus'))">
              <div *ngFor="let category_activities_forcus of checkNull(searchResultList, 'category_activities_forcus')">
                {{ category_activities_forcus.name }}
              </div>
            </td>
          </tr>
          <!-- SDGsで目指すゴール -->
          <tr>
            <td class="item-name">SDGsで目指すゴール</td>
            <td class="item-information target-goal">
              <div class="image"
                *ngFor="let category_activities of checkNull(searchResultLogList, 'category_activities')">
                <img [src]="category_activities.sp_ext" alt="image" />
              </div>
            </td>
            <td class="item-information target-goal"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'category_activities')) == convertJSONtoString(checkNull(searchResultList, 'category_activities'))">
              <div class="image" *ngFor="let category_activities of checkNull(searchResultList, 'category_activities')">
                <img [src]="category_activities.sp_ext" alt="image" />
              </div>
            </td>
            <td class="item-information target-goal unmatched"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'category_activities')) != convertJSONtoString(checkNull(searchResultList, 'category_activities'))">
              <div class="image" *ngFor="let category_activities of checkNull(searchResultList, 'category_activities')">
                <img [src]="category_activities.sp_ext" alt="image" />
              </div>
            </td>
          </tr>
          <!-- 現在のSDGsに関する取組 -->
          <tr>
            <td class="item-name">現在のSDGsに関する取組</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'activities_now') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'activities_now') == checkNull(searchResultList, 'activities_now')">
              {{ checkNull(searchResultList, 'activities_now') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'activities_now') != checkNull(searchResultList, 'activities_now')">
              {{ checkNull(searchResultList, 'activities_now') }}</td>
          </tr>
          <!-- 今後取り組みたい内容 -->
          <tr>
            <td class="item-name">今後取り組みたい内容</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'activities_future') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'activities_future') == checkNull(searchResultList, 'activities_future')">
              {{ checkNull(searchResultList, 'activities_future') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'activities_future') != checkNull(searchResultList, 'activities_future')">
              {{ checkNull(searchResultList, 'activities_future') }}</td>
          </tr>
          <!-- 官民連携事例 -->
          <tr *ngIf="checkNull(searchResultList, 'pap_ally1_title')">
            <td class="item-name">官民連携事例1</td>
            <td class="item-information">
              【案件名】<br />
              {{ checkNull(searchResultLogList, 'pap_ally1_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultLogList, 'pap_ally1_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultLogList, 'pap_ally1_note') }}
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'pap_ally1_title') == checkNull(searchResultList, 'pap_ally1_title') &&
                       checkNull(searchResultLogList, 'pap_ally1_member_name') == checkNull(searchResultList, 'pap_ally1_member_name') &&
                       checkNull(searchResultLogList, 'pap_ally1_note') == checkNull(searchResultList, 'pap_ally1_note')">
              【案件名】<br />
              {{ checkNull(searchResultList, 'pap_ally1_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultList, 'pap_ally1_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultList, 'pap_ally1_note') }}
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'pap_ally1_title') != checkNull(searchResultList, 'pap_ally1_title') ||
                       checkNull(searchResultLogList, 'pap_ally1_member_name') != checkNull(searchResultList, 'pap_ally1_member_name') ||
                       checkNull(searchResultLogList, 'pap_ally1_note') != checkNull(searchResultList, 'pap_ally1_note'); else profile_pap_ally1">
              【案件名】<br />
              {{ checkNull(searchResultList, 'pap_ally1_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultList, 'pap_ally1_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultList, 'pap_ally1_note') }}
            </td>
          </tr>
          <!-- 官民連携事例 -->
          <tr *ngIf="checkNull(searchResultList, 'pap_ally2_title')">
            <td class="item-name">官民連携事例2</td>
            <td class="item-information">
              【案件名】<br />
              {{ checkNull(searchResultLogList, 'pap_ally2_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultLogList, 'pap_ally2_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultLogList, 'pap_ally2_note') }}
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'pap_ally2_title') == checkNull(searchResultList, 'pap_ally2_title') &&
                       checkNull(searchResultLogList, 'pap_ally2_member_name') == checkNull(searchResultList, 'pap_ally2_member_name') &&
                       checkNull(searchResultLogList, 'pap_ally2_note') == checkNull(searchResultList, 'pap_ally2_note')">
              【案件名】<br />
              {{ checkNull(searchResultList, 'pap_ally2_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultList, 'pap_ally2_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultList, 'pap_ally2_note') }}
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'pap_ally2_title') != checkNull(searchResultList, 'pap_ally2_title') ||
                       checkNull(searchResultLogList, 'pap_ally2_member_name') != checkNull(searchResultList, 'pap_ally2_member_name') ||
                       checkNull(searchResultLogList, 'pap_ally2_note') != checkNull(searchResultList, 'pap_ally2_note'); else profile_pap_ally2">
              【案件名】<br />
              {{ checkNull(searchResultList, 'pap_ally2_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultList, 'pap_ally2_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultList, 'pap_ally2_note') }}
            </td>
          </tr>
          <!-- 官民連携事例 -->
          <tr *ngIf="checkNull(searchResultList, 'pap_ally3_title')">
            <td class="item-name">官民連携事例3</td>
            <td class="item-information">
              【案件名】<br />
              {{ checkNull(searchResultLogList, 'pap_ally3_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultLogList, 'pap_ally3_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultLogList, 'pap_ally3_note') }}
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'pap_ally3_title') == checkNull(searchResultList, 'pap_ally3_title') &&
                       checkNull(searchResultLogList, 'pap_ally3_member_name') == checkNull(searchResultList, 'pap_ally3_member_name') &&
                       checkNull(searchResultLogList, 'pap_ally3_note') == checkNull(searchResultList, 'pap_ally3_note')">
              【案件名】<br />
              {{ checkNull(searchResultList, 'pap_ally3_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultList, 'pap_ally3_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultList, 'pap_ally3_note') }}
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'pap_ally3_title') != checkNull(searchResultList, 'pap_ally3_title') ||
                       checkNull(searchResultLogList, 'pap_ally3_member_name') != checkNull(searchResultList, 'pap_ally3_member_name') ||
                       checkNull(searchResultLogList, 'pap_ally3_note') != checkNull(searchResultList, 'pap_ally3_note'); else profile_pap_ally3">
              【案件名】<br />
              {{ checkNull(searchResultList, 'pap_ally3_title') }}<br />
              【連携団体名】<br />
              {{ checkNull(searchResultList, 'pap_ally3_member_name') }}<br />
              【詳細】<br />
              {{ checkNull(searchResultList, 'pap_ally3_note') }}
            </td>
          </tr>
        </ng-container>
        <!--------------------------------------------------------------------------------------------->
        <!-- c301 課題・ソリューション -->
        <!--------------------------------------------------------------------------------------------->
        <ng-container *ngIf="screen_id == 'c301'">
          <!-- 区分 -->
          <tr>
            <td class="item-name">区分</td>
            <td class="item-information">
              <!-- 区分が1の場合 -->
              <p-tag value="課題" styleClass="task-tag" *ngIf="1 == checkNull(searchResultLogList, 'agenda_kbn', 'id')">
              </p-tag>
              <!-- 区分が2の場合 -->
              <p-tag value="ソリューション" styleClass="solution-tag"
                *ngIf="2 == checkNull(searchResultLogList, 'agenda_kbn', 'id')"></p-tag>
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'agenda_kbn', 'id') == checkNull(searchResultList, 'agenda_kbn', 'id')">
              <!-- 区分が1の場合 -->
              <p-tag value="課題" styleClass="task-tag" *ngIf="1 == checkNull(searchResultList, 'agenda_kbn', 'id')">
              </p-tag>
              <!-- 区分が2の場合 -->
              <p-tag value="ソリューション" styleClass="solution-tag"
                *ngIf="2 == checkNull(searchResultList, 'agenda_kbn', 'id')"></p-tag>
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'agenda_kbn', 'id') != checkNull(searchResultList, 'agenda_kbn', 'id')">
              <!-- 区分が1の場合 -->
              <p-tag value="課題" styleClass="task-tag" *ngIf="1 == checkNull(searchResultList, 'agenda_kbn', 'id')">
              </p-tag>
              <!-- 区分が2の場合 -->
              <p-tag value="ソリューション" styleClass="solution-tag"
                *ngIf="2 == checkNull(searchResultList, 'agenda_kbn', 'id')"></p-tag>
            </td>
          </tr>
          <!-- タイトル -->
          <tr>
            <td class="item-name">タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'title') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'title') == checkNull(searchResultList, 'title')">{{
              checkNull(searchResultList, 'title') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'title') != checkNull(searchResultList, 'title')">{{
              checkNull(searchResultList, 'title') }}</td>
          </tr>
          <!-- カテゴリ -->
          <tr>
            <td class="item-name">カテゴリ</td>
            <td class="item-information">
              <div *ngFor="let category of checkNull(searchResultLogList, 'category')">
                {{ category.name }}
              </div>
            </td>
            <td class="item-information"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'category')) == convertJSONtoString(checkNull(searchResultList, 'category'))">
              <div *ngFor="let category of checkNull(searchResultList, 'category')">
                {{ category.name }}
              </div>
            </td>
            <td class="item-information unmatched"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'category')) != convertJSONtoString(checkNull(searchResultList, 'category'))">
              <div *ngFor="let category of checkNull(searchResultList, 'category')">
                {{ category.name }}
              </div>
            </td>
          </tr>
          <!-- ソリューション内容 -->
          <tr *ngIf="2 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">ソリューション内容</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'solution_detail') }}
              <img class="view-content" [src]="checkNull(searchResultLogList, 'image', 'file_path')" alt="image"
                id="image1" *ngIf="checkNull(searchResultLogList, 'image', 'id')" />
            </td>
            <td class="item-information" *ngIf="checkNull(searchResultLogList, 'solution_detail') == checkNull(searchResultList, 'solution_detail')
                && checkNull(searchResultLogList, 'image','id') == checkNull(searchResultList, 'image','id')">
              {{ checkNull(searchResultList, 'solution_detail') }}
              <img class="view-content" [src]="checkNull(searchResultList, 'image', 'file_path')" alt="image"
                id="image1" *ngIf="checkNull(searchResultList, 'image', 'id')" />
            </td>
            <td class="item-information unmatched" *ngIf="checkNull(searchResultLogList, 'solution_detail') != checkNull(searchResultList, 'solution_detail')
                || checkNull(searchResultLogList, 'image','id') != checkNull(searchResultList, 'image','id')">
              {{ checkNull(searchResultList, 'solution_detail') }}
              <img class="view-content" [src]="checkNull(searchResultList, 'image', 'file_path')" alt="image"
                id="image1" *ngIf="checkNull(searchResultList, 'image', 'id')" />
            </td>
          </tr>
          <!-- 連携希望先 -->
          <tr *ngIf="2 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">連携希望先</td>
            <td class="item-information">
              <div *ngFor="let image_group of checkNull(searchResultLogList, 'image_group')">
                {{ image_group.name }}
              </div>
            </td>
            <td class="item-information"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'image_group')) == convertJSONtoString(checkNull(searchResultList, 'image_group'))">
              <div *ngFor="let image_group of checkNull(searchResultList, 'image_group')">
                {{ image_group.name }}
              </div>
            </td>
            <td class="item-information unmatched"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'image_group')) != convertJSONtoString(checkNull(searchResultList, 'image_group'))">
              <div *ngFor="let image_group of checkNull(searchResultList, 'image_group')">
                {{ image_group.name }}
              </div>
            </td>
          </tr>
          <!-- 解決したい課題内容 -->
          <tr *ngIf="1 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">解決したい課題内容</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'agenda')}}
              <img class="view-content" [src]="checkNull(searchResultLogList, 'image', 'file_path')" alt="image"
                id="image1" *ngIf="checkNull(searchResultLogList, 'image', 'id')" />
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'agenda') == checkNull(searchResultList, 'agenda') && checkNull(searchResultLogList, 'image','id') == checkNull(searchResultList, 'image','id')">
              {{ checkNull(searchResultList, 'agenda') }}
              <img class="view-content" [src]="checkNull(searchResultList, 'image', 'file_path')" alt="image"
                id="image1" *ngIf="checkNull(searchResultList, 'image', 'id')" />
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'agenda') != checkNull(searchResultList, 'agenda') || checkNull(searchResultLogList, 'image','id') != checkNull(searchResultList, 'image','id')">
              {{ checkNull(searchResultList, 'agenda') }}
              <img class="view-content" [src]="checkNull(searchResultList, 'image', 'file_path')" alt="image"
                id="image1" *ngIf="checkNull(searchResultList, 'image', 'id')" />
            </td>
          </tr>
          <!-- 課題に対する現在の取り組み -->
          <tr *ngIf="1 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">課題に対する現在の取組</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'measures') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'measures') == checkNull(searchResultList, 'measures')">{{
              checkNull(searchResultList, 'measures') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'measures') != checkNull(searchResultList, 'measures')">{{
              checkNull(searchResultList, 'measures') }}</td>
          </tr>
          <!-- 提案者側に期待すること -->
          <tr *ngIf="1 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">提案者側に期待すること</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'expectations') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'expectations') == checkNull(searchResultList, 'expectations')">{{
              checkNull(searchResultList, 'expectations') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'expectations') != checkNull(searchResultList, 'expectations')">{{
              checkNull(searchResultList, 'expectations') }}</td>
          </tr>

          <!--掲載終了日-->
          <tr>
            <td class="item-name">掲載終了日</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'end_date') }}</td>
            <td class="item-information" *ngIf="checkNull(searchResultLogList, 'end_date') == checkNull(searchResultList, 'end_date')" >{{ checkNull(searchResultList, 'end_date') }}</td>
            <td class="item-information unmatched" *ngIf="checkNull(searchResultLogList, 'end_date') != checkNull(searchResultList, 'end_date')" >{{ checkNull(searchResultList, 'end_date') }}</td>
          </tr>
          <!--公開掲示板の設置-->
          <tr>
            <td class="item-name">公開掲示板の設置</td>
            <td class="item-information">
              <!-- 区分が0の場合 -->
              <label *ngIf="0 == checkNull(searchResultLogList, 'board_open', 'id')">設置しない</label>
              <!-- 区分が1の場合 -->
              <label *ngIf="1 == checkNull(searchResultLogList, 'board_open', 'id')">設置する</label>
            </td>
            <td class="item-information" *ngIf="checkNull(searchResultLogList, 'board_open', 'id') == checkNull(searchResultList, 'board_open', 'id')">
              <!-- 区分が1の場合 -->
              <label *ngIf="0 == checkNull(searchResultList, 'board_open', 'id')">設置しない</label>
              <!-- 区分が2の場合 -->
              <label *ngIf="1 == checkNull(searchResultList, 'board_open', 'id')">設置する</label>
            </td>
            <td class="item-information unmatched" *ngIf="checkNull(searchResultLogList, 'board_open', 'id') != checkNull(searchResultList, 'board_open', 'id')">
              <!-- 区分が1の場合 -->
              <label *ngIf="0 == checkNull(searchResultList, 'board_open', 'id')">設置しない</label>
              <!-- 区分が2の場合 -->
              <label *ngIf="1 == checkNull(searchResultList, 'board_open', 'id')">設置する</label>
            </td>
          </tr>

          <!-- 定量的な目標値 -->
          <tr *ngIf="1 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">定量的な目標値</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'target') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'target') == checkNull(searchResultList, 'target')">{{
              checkNull(searchResultList, 'target') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'target') != checkNull(searchResultList, 'target')">{{
              checkNull(searchResultList, 'target') }}</td>
          </tr>
          <!-- 現時点の予算状況 -->
          <tr *ngIf="1 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">現時点の予算状況</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'budget',
              'name')}}<br>{{checkNull(searchResultLogList, 'budget_note') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'budget', 'name') + checkNull(searchResultLogList, 'budget_note') === checkNull(searchResultList, 'budget', 'name') + checkNull(searchResultList, 'budget_note')">
              {{ checkNull(searchResultList, 'budget', 'name')}}<br>{{checkNull(searchResultList, 'budget_note') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'budget', 'name') + checkNull(searchResultLogList, 'budget_note') !== checkNull(searchResultList, 'budget', 'name') + checkNull(searchResultList, 'budget_note')">
              {{ checkNull(searchResultList, 'budget', 'name')}}<br>{{checkNull(searchResultList, 'budget_note') }}</td>
          </tr>
          <!-- 予算化の方法	 -->
          <tr *ngIf="1 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">予算化の方法</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'budget_method') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'budget_method') == checkNull(searchResultList, 'budget_method')">{{
              checkNull(searchResultList, 'budget_method') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'budget_method') != checkNull(searchResultList, 'budget_method')">{{
              checkNull(searchResultList, 'budget_method') }}</td>
          </tr>
          <!-- 達成したいゴール -->
          <tr>
            <td class="item-name">達成したいゴール</td>
            <td class="item-information target-goal">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultLogList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
            <td class="item-information target-goal"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'sdgs_goal')) == convertJSONtoString(checkNull(searchResultList, 'sdgs_goal'))">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
            <td class="item-information target-goal unmatched"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'sdgs_goal')) != convertJSONtoString(checkNull(searchResultList, 'sdgs_goal'))">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
          </tr>
          <!-- ソリューション紹介WebサイトURL -->
          <tr *ngIf="2 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">ソリューション紹介<br>ウェブサイトURL</td>
            <td class="item-information">
              <a [href]="checkNull(searchResultLogList, 'solution_url')" target="_blank">{{
                checkNull(searchResultLogList, 'solution_url') }}</a>
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'solution_url') == checkNull(searchResultList, 'solution_url')">
              <a [href]="checkNull(searchResultList, 'solution_url')" target="_blank">{{ checkNull(searchResultList,
                'solution_url') }}</a>
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'solution_url') != checkNull(searchResultList, 'solution_url')">
              <a [href]="checkNull(searchResultList, 'solution_url')" target="_blank">{{ checkNull(searchResultList,
                'solution_url') }}</a>
            </td>
          </tr>
          <!-- ソリューション補足 -->
          <tr *ngIf="2 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">ソリューション補足</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'solution_note') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'solution_note') == checkNull(searchResultList, 'solution_note')">{{
              checkNull(searchResultList, 'solution_note') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'solution_note') != checkNull(searchResultList, 'solution_note')">{{
              checkNull(searchResultList, 'solution_note') }}</td>
          </tr>
          <!-- 導入費用等の情報	 -->
          <tr *ngIf="2 == checkNull(searchResultList, 'agenda_kbn', 'id')">
            <td class="item-name">導入費用等の情報</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'introcost_info') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'introcost_info') == checkNull(searchResultList, 'introcost_info')">
              {{ checkNull(searchResultList, 'introcost_info') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'introcost_info') != checkNull(searchResultList, 'introcost_info')">
              {{ checkNull(searchResultList, 'introcost_info') }}</td>
          </tr>
        </ng-container>
        <!--------------------------------------------------------------------------------------------->
        <!-- h301 -->
        <!--------------------------------------------------------------------------------------------->
        <ng-container *ngIf="screen_id == 'h301'">
          <!-- タイトル -->
          <tr>
            <td class="item-name">タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'title') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'title') == checkNull(searchResultList, 'title')">{{
              checkNull(searchResultList, 'title') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'title') != checkNull(searchResultList, 'title')">{{
              checkNull(searchResultList, 'title') }}</td>
          </tr>
          <!-- 概要 -->
          <tr>
            <td class="item-name">概要</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'attemptoverview') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'attemptoverview') == checkNull(searchResultList, 'attemptoverview')">
              {{ checkNull(searchResultList, 'attemptoverview') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'attemptoverview') != checkNull(searchResultList, 'attemptoverview')">
              {{ checkNull(searchResultList, 'attemptoverview') }}</td>
          </tr>
          <!-- 図・写真①-->
          <tr>
            <td class="item-name">図・写真①</td>
            <td class="item-information">
              <img *ngIf="checkNull(searchResultLogList, 'case_image1','file_path')"
                [src]="searchResultLogList?.case_image1.file_path" alt="image" width="100%" />
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'case_image1', 'file_path') == checkNull(searchResultList, 'case_image1', 'file_path')">
              <img [src]="searchResultList?.case_image1.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'case_image1', 'id')" />
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'case_image1', 'file_path') != checkNull(searchResultList, 'case_image1', 'file_path')">
              <img [src]="searchResultList?.case_image1.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'case_image1', 'id')" />
            </td>
          </tr>
          <!-- 図・写真①タイトル -->
          <tr>
            <td class="item-name">図・写真①タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'case_image1_caption') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'case_image1_caption') == checkNull(searchResultList, 'case_image1_caption')">
              {{ checkNull(searchResultList, 'case_image1_caption') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'case_image1_caption') != checkNull(searchResultList, 'case_image1_caption')">
              {{ checkNull(searchResultList, 'case_image1_caption') }}</td>
          </tr>
          <!-- 図・写真②-->
          <tr>
            <td class="item-name">図・写真②</td>
            <td class="item-information">
              <img *ngIf="checkNull(searchResultLogList, 'case_image2','file_path')"
                [src]="searchResultLogList?.case_image2.file_path" alt="image" width="100%" />
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'case_image2', 'file_path') == checkNull(searchResultList, 'case_image2', 'file_path')">
              <img [src]="searchResultList?.case_image2.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'case_image2', 'id')" />
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'case_image2', 'file_path') != checkNull(searchResultList, 'case_image2', 'file_path')">
              <img [src]="searchResultList?.case_image2.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'case_image2', 'id')" />
            </td>
          </tr>
          <!-- 図・写真②タイトル -->
          <tr>
            <td class="item-name">図・写真②タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'case_image2_caption') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'case_image2_caption') == checkNull(searchResultList, 'case_image2_caption')">
              {{ checkNull(searchResultList, 'case_image2_caption') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'case_image2_caption') != checkNull(searchResultList, 'case_image2_caption')">
              {{ checkNull(searchResultList, 'case_image2_caption') }}</td>
          </tr>
          <!-- 代表地方公共団体等の都道府県 -->
          <tr>
            <td class="item-name">代表地方公共団体等の都道府県</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'prefectures') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'prefectures') == checkNull(searchResultList, 'prefectures')">
              {{ checkNull(searchResultList, 'prefectures') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'prefectures') != checkNull(searchResultList, 'prefectures')">
              {{ checkNull(searchResultList, 'prefectures') }}</td>
          </tr>
          <!-- 代表地方公共団体等 -->
          <tr>
            <td class="item-name">代表地方公共団体等</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'public_representative') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'public_representative') == checkNull(searchResultList, 'public_representative')">
              {{ checkNull(searchResultList, 'public_representative') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'public_representative') != checkNull(searchResultList, 'public_representative')">
              {{ checkNull(searchResultList, 'public_representative') }}</td>
          </tr>
          <!-- 代表民間団体等 -->
          <tr>
            <td class="item-name">代表民間団体等</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'private_representatibe') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'private_representatibe') == checkNull(searchResultList, 'private_representatibe')">
              {{ checkNull(searchResultList, 'private_representatibe') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'private_representatibe') != checkNull(searchResultList, 'private_representatibe')">
              {{ checkNull(searchResultList, 'private_representatibe') }}</td>
          </tr>
          <!-- 他の連携団体等 -->
          <tr>
            <td class="item-name">他の連携団体等</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'other_cooperation') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'other_cooperation') == checkNull(searchResultList, 'other_cooperation')">
              {{ checkNull(searchResultList, 'other_cooperation') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'other_cooperation') != checkNull(searchResultList, 'other_cooperation')">
              {{ checkNull(searchResultList, 'other_cooperation') }}</td>
          </tr>
          <!-- 事例タグ -->
          <tr>
            <td class="item-name">事例タグ</td>
            <td class="item-information">
              <p-tag value="PF会員間連携" styleClass="p-button-text tag-type2"
                *ngIf="checkNull(searchResultLogList, 'case_tag')"></p-tag>
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'case_tag') == checkNull(searchResultList, 'case_tag')">
              <p-tag value="PF会員間連携" styleClass="p-button-text tag-type2"
                *ngIf="searchResultList?.case_tag.includes('1')"></p-tag>
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'case_tag') != checkNull(searchResultList, 'case_tag')">
              <p-tag value="PF会員間連携" styleClass="p-button-text tag-type2"
                *ngIf="searchResultList?.case_tag.includes('1')"></p-tag>
            </td>
          </tr>
          <!-- カテゴリ -->
          <tr>
            <td class="item-name">カテゴリ</td>
            <td class="item-information">
              <div *ngFor="let category of checkNull(searchResultLogList, 'category')">
                {{ category.name }}
              </div>
            </td>
            <td class="item-information"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'category')) == convertJSONtoString(checkNull(searchResultList, 'category'))">
              <div *ngFor="let category of checkNull(searchResultList, 'category')">
                {{ category.name }}
              </div>
            </td>
            <td class="item-information unmatched"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'category')) != convertJSONtoString(checkNull(searchResultList, 'category'))">
              <div *ngFor="let category of checkNull(searchResultList, 'category')">
                {{ category.name }}
              </div>
            </td>
          </tr>
          <!-- 事業費 -->
          <tr>
            <td class="item-name">事業費</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'business_cost') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'business_cost') == checkNull(searchResultList, 'business_cost')">{{
              checkNull(searchResultList, 'business_cost') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'business_cost') != checkNull(searchResultList, 'business_cost')">{{
              checkNull(searchResultList, 'business_cost') }}</td>
          </tr>
          <!-- SDGsで目指すゴール -->
          <tr>
            <td class="item-name">SDGsで目指すゴール</td>
            <td class="item-information target-goal">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultLogList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
            <td class="item-information target-goal"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'sdgs_goal')) == convertJSONtoString(checkNull(searchResultList, 'sdgs_goal'))">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
            <td class="item-information target-goal unmatched"
              *ngIf="convertJSONtoString(checkNull(searchResultLogList, 'sdgs_goal')) != convertJSONtoString(checkNull(searchResultList, 'sdgs_goal'))">
              <div class="image" *ngFor="let sdgs_goal of checkNull(searchResultList, 'sdgs_goal')">
                <img [src]="sdgs_goal.sp_ext" alt="image" />
              </div>
            </td>
          </tr>
          <!-- 事業化までの期間 -->
          <tr>
            <td class="item-name">事業化までの期間</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'coopstart_season') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'coopstart_season') == checkNull(searchResultList, 'coopstart_season')">
              {{ checkNull(searchResultList, 'coopstart_season') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'coopstart_season') != checkNull(searchResultList, 'coopstart_season')">
              {{ checkNull(searchResultList, 'coopstart_season') }}</td>
          </tr>
          <!-- この取組で解決した課題 -->
          <tr>
            <td class="item-name">この取組で解決した課題</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'clear_agenda') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'clear_agenda') == checkNull(searchResultList, 'clear_agenda')">{{
              checkNull(searchResultList, 'clear_agenda') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'clear_agenda') != checkNull(searchResultList, 'clear_agenda')">{{
              checkNull(searchResultList, 'clear_agenda') }}</td>
          </tr>
          <!-- 解決に向けた手法 -->
          <tr>
            <td class="item-name">解決に向けた手法</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'method') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'method') == checkNull(searchResultList, 'method')">{{
              checkNull(searchResultList, 'method') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'method') != checkNull(searchResultList, 'method')">{{
              checkNull(searchResultList, 'method') }}</td>
          </tr>
          <!-- 図・写真③-->
          <tr>
            <td class="item-name">図・写真③</td>
            <td class="item-information">
              <img *ngIf="checkNull(searchResultLogList, 'overview_image1','file_path')"
                [src]="searchResultLogList?.overview_image1.file_path" alt="image" width="100%" />
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'overview_image1', 'file_path') == checkNull(searchResultList, 'overview_image1', 'file_path')">
              <img [src]="searchResultList?.overview_image1.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'overview_image1', 'id')" />
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'overview_image1', 'file_path') != checkNull(searchResultList, 'overview_image1', 'file_path')">
              <img [src]="searchResultList?.overview_image1.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'overview_image1', 'id')" />
            </td>
          </tr>
          <!-- 図・写真③タイトル -->
          <tr>
            <td class="item-name">図・写真③タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'overview_image1_caption') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'overview_image1_caption') == checkNull(searchResultList, 'overview_image1_caption')">
              {{ checkNull(searchResultList, 'overview_image1_caption') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'overview_image1_caption') != checkNull(searchResultList, 'overview_image1_caption')">
              {{ checkNull(searchResultList, 'overview_image1_caption') }}</td>
          </tr>
          <!-- 図・写真④-->
          <tr>
            <td class="item-name">図・写真④</td>
            <td class="item-information">
              <img *ngIf="checkNull(searchResultLogList, 'overview_image2','file_path')"
                [src]="searchResultLogList?.overview_image2.file_path" alt="image" width="100%" />
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'overview_image2', 'file_path') == checkNull(searchResultList, 'overview_image2', 'file_path')">
              <img [src]="searchResultList?.overview_image2.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'overview_image2', 'id')" />
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'overview_image2', 'file_path') != checkNull(searchResultList, 'overview_image2', 'file_path')">
              <img [src]="searchResultList?.overview_image2.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'overview_image2', 'id')" />
            </td>
          </tr>
          <!-- 図・写真④タイトル -->
          <tr>
            <td class="item-name">図・写真④タイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'overview_image2_caption') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'overview_image2_caption') == checkNull(searchResultList, 'overview_image2_caption')">
              {{ checkNull(searchResultList, 'overview_image2_caption') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'overview_image2_caption') != checkNull(searchResultList, 'overview_image2_caption')">
              {{ checkNull(searchResultList, 'overview_image2_caption') }}</td>
          </tr>
          <!-- 事業推進上の各団体の役割分担 -->
          <tr>
            <td class="item-name">事業推進上の各団体の役割分担</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'role_sharing') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'role_sharing') == checkNull(searchResultList, 'role_sharing')">{{
              checkNull(searchResultList, 'role_sharing') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'role_sharing') != checkNull(searchResultList, 'role_sharing')">{{
              checkNull(searchResultList, 'role_sharing') }}</td>
          </tr>
          <!-- 地域関係者との連携方法 -->
          <tr>
            <td class="item-name">地域関係者との連携方法</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'coop_method') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'coop_method') == checkNull(searchResultList, 'coop_method')">{{
              checkNull(searchResultList, 'coop_method') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'coop_method') != checkNull(searchResultList, 'coop_method')">{{
              checkNull(searchResultList, 'coop_method') }}</td>
          </tr>
          <!-- 資金調達方法 -->
          <tr>
            <td class="item-name">資金調達方法</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'funding_plan') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'funding_plan') == checkNull(searchResultList, 'funding_plan')">{{
              checkNull(searchResultList, 'funding_plan') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'funding_plan') != checkNull(searchResultList, 'funding_plan')">{{
              checkNull(searchResultList, 'funding_plan') }}</td>
          </tr>
          <!-- 資金調達方法の補足 -->
          <tr>
            <td class="item-name">資金調達方法の補足</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'funding_plan_supplement') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'funding_plan_supplement') == checkNull(searchResultList, 'funding_plan_supplement')">
              {{ checkNull(searchResultList, 'funding_plan_supplement') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'funding_plan_supplement') != checkNull(searchResultList, 'funding_plan_supplement')">
              {{ checkNull(searchResultList, 'funding_plan_supplement') }}</td>
          </tr>
          <!-- 事業推進上の課題・工夫 -->
          <tr>
            <td class="item-name">事業推進上の課題・工夫</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'solution') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'solution') == checkNull(searchResultList, 'solution')">{{
              checkNull(searchResultList, 'solution') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'solution') != checkNull(searchResultList, 'solution')">{{
              checkNull(searchResultList, 'solution') }}</td>
          </tr>
          <!-- 担当者のコメント -->
          <tr>
            <td class="item-name">担当者のコメント</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'responsible_person_comment') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'responsible_person_comment') == checkNull(searchResultList, 'responsible_person_comment')">
              {{ checkNull(searchResultList, 'responsible_person_comment') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'responsible_person_comment') != checkNull(searchResultList, 'responsible_person_comment')">
              {{ checkNull(searchResultList, 'responsible_person_comment') }}</td>
          </tr>
          <!-- 担当者の写真等-->
          <tr>
            <td class="item-name">担当者の写真等</td>
            <td class="item-information">
              <img *ngIf="checkNull(searchResultLogList, 'responsible_person_image','file_path')"
                [src]="searchResultLogList?.responsible_person_image.file_path" alt="image" width="100%" />
            </td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'responsible_person_image', 'file_path') == checkNull(searchResultList, 'responsible_person_image', 'file_path')">
              <img [src]="searchResultList?.responsible_person_image.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'responsible_person_image', 'id')" />
            </td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'responsible_person_image', 'file_path') != checkNull(searchResultList, 'responsible_person_image', 'file_path')">
              <img [src]="searchResultList?.responsible_person_image.file_path" alt="image" width="100%"
                *ngIf="checkNull(searchResultList, 'responsible_person_image', 'id')" />
            </td>
          </tr>
          <!-- 写真等のタイトル -->
          <tr>
            <td class="item-name">写真等のタイトル</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'responsible_person_caption') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'responsible_person_caption') == checkNull(searchResultList, 'responsible_person_caption')">
              {{ checkNull(searchResultList, 'responsible_person_caption') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'responsible_person_caption') != checkNull(searchResultList, 'responsible_person_caption')">
              {{ checkNull(searchResultList, 'responsible_person_caption') }}</td>
          </tr>
          <!-- 公開設定 -->
          <tr>
            <td class="item-name">公開設定</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'cooperation_open', 'name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'cooperation_open', 'name') == checkNull(searchResultList, 'cooperation_open', 'name')">
              {{ checkNull(searchResultList, 'cooperation_open', 'name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'cooperation_open', 'name') != checkNull(searchResultList, 'cooperation_open', 'name')">
              {{ checkNull(searchResultList, 'cooperation_open', 'name') }}</td>
          </tr>
          <!-- 団体名称（全角） -->
          <tr>
            <td class="item-name">団体名称（全角）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'organization_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'organization_name') == checkNull(searchResultList, 'organization_name')">
              {{ checkNull(searchResultList, 'organization_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'organization_name') != checkNull(searchResultList, 'organization_name')">
              {{ checkNull(searchResultList, 'organization_name') }}</td>
          </tr>
          <!-- 部局名（全角） -->
          <tr>
            <td class="item-name">部局名（全角）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'divition_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'divition_name') == checkNull(searchResultList, 'divition_name')">{{
              checkNull(searchResultList, 'divition_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'divition_name') != checkNull(searchResultList, 'divition_name')">{{
              checkNull(searchResultList, 'divition_name') }}</td>
          </tr>
          <!-- 氏名（全角） -->
          <tr>
            <td class="item-name">氏名（全角）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'responsible_person_name') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'responsible_person_name') == checkNull(searchResultList, 'responsible_person_name')">
              {{ checkNull(searchResultList, 'responsible_person_name') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'responsible_person_name') != checkNull(searchResultList, 'responsible_person_name')">
              {{ checkNull(searchResultList, 'responsible_person_name') }}</td>
          </tr>
          <!-- 電話番号（半角数字、ハイフン不要） -->
          <tr>
            <td class="item-name">電話番号（半角数字、ハイフン不要）</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'tel') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'tel') == checkNull(searchResultList, 'tel')">{{
              checkNull(searchResultList, 'tel') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'tel') != checkNull(searchResultList, 'tel')">{{
              checkNull(searchResultList, 'tel') }}</td>
          </tr>
          <!-- eメールアドレス -->
          <tr>
            <td class="item-name">eメールアドレス</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'email') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'email') == checkNull(searchResultList, 'email')">{{
              checkNull(searchResultList, 'email') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'email') != checkNull(searchResultList, 'email')">{{
              checkNull(searchResultList, 'email') }}</td>
          </tr>
          <!-- 応募にあたっての記載事項 -->
          <tr>
            <td class="item-name">応募にあたっての記載事項</td>
            <td class="item-information">{{ checkNull(searchResultLogList, 'sdgs_perspective') }}</td>
            <td class="item-information"
              *ngIf="checkNull(searchResultLogList, 'sdgs_perspective') == checkNull(searchResultList, 'sdgs_perspective')">
              {{ checkNull(searchResultList, 'sdgs_perspective') }}</td>
            <td class="item-information unmatched"
              *ngIf="checkNull(searchResultLogList, 'sdgs_perspective') != checkNull(searchResultList, 'sdgs_perspective')">
              {{ checkNull(searchResultList, 'sdgs_perspective') }}</td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>
</p-dialog>